import { styled } from '@mui/material';

const Field = styled('div')(() => ({
  marginTop: '1.5rem',
  marginBottom: '1.5rem',
}));

export default Field;
